import { useEffect } from "react";
import { useAppStore } from "@/hooks/use-app-store";
import { Toaster } from "@/components/ui/sonner";
import { IdleCountdownManager } from "@/lib/idle-manager";
import type { PersonaId } from "@/types/persona";
import { DEFAULT_PERSONA } from "@/types/persona";

const IDLE_TIMEOUT_MS = 90 * 1000;
const IDLE_CHECK_INTERVAL_MS = 10 * 1000;

type DEAIAppProps = {
  idleTimeout?: number;
  contextProvider?:()=>object;
  persona?: PersonaId;
}

export const DEAIApp = ({ idleTimeout = IDLE_TIMEOUT_MS, contextProvider, persona = DEFAULT_PERSONA }: DEAIAppProps) => {
  // TODO make appStore persona specific?
  const { initialize, isConnected, isStarted } = useAppStore();


  // Effect for initial connection
  useEffect(() => {
    if(!isConnected) {
      initialize(contextProvider, persona); 
    }
  }, [initialize, isConnected, contextProvider, persona]);

  // Effect to listen for global user activity
  useEffect(() => {
    // The update function is now called directly on every event.
    const handleActivity = () => {
      IdleCountdownManager.updateActivity();
      IdleCountdownManager.cancel();
    };

    const activityEvents: (keyof WindowEventMap)[] = ['mousemove', 'click', 'keydown', 'scroll'];
    activityEvents.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    // Cleanup function to remove listeners
    return () => {
      activityEvents.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);


  // Effect for the idle checker timer - only runs when experience has started
  useEffect(() => {
    if (!isConnected || !isStarted || idleTimeout == -1) return;
    const idleCheckInterval = setInterval(() => {
      const isIdle = Date.now() - IdleCountdownManager.getLastActivity() > idleTimeout;
      if (isIdle) {
        IdleCountdownManager.start();
      }
    }, IDLE_CHECK_INTERVAL_MS);
    return () => clearInterval(idleCheckInterval);
  }, [isConnected, isStarted, idleTimeout]);

  return (
    <>
      <Toaster position="top-center" richColors theme="light" />
    </>
  );
};